<template>
  <div class="progress">
    <div class="progress-titles">
      <div>
        Create Account
        <span>(30 Seconds)</span>
      </div>
      <div>
        Start Plan
        <span>(30 Seconds)</span>
      </div>
    </div>
    <div class="progress-status">
      <div
        class="progress-status_bar"
        :class="{
          'complete': completed,
          'reseller' : reseller,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    completed: {
      type: Boolean,
      required: true,
    },
    reseller: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  align-items: center;
  width: 80%;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 2rem;

  .progress-titles {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .progress-status {
    background-color: #E9E9E9;
    border-radius: 13px;
    width: 80%;
    height: 10px;
  }

  .progress-status_bar {
    background-color: #0B132B;
    width: 50%;
    border-radius: 10px 0 0 10px;
    height: 10px;
    transition: width 0.5s;

    &.reseller {
      background-color: #9D61EF;
    }
  }

  .complete {
    width: 100%;
    border-radius: 10px;
    transition: width 0.5s;
  }
}

@media only screen and (max-width: 900px) {
  .progress {
    width: 90%;
  }
}
@media only screen and (max-width: 519px) {
  .progress {
    flex-direction: column;

    .progress-titles {
      > div {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
